module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "About Us - Leaders.1ec47764.jpg" + "?" + Date.now();